import { ReactNode } from "react";
import cx from "classnames";

import Box, { BoxProps } from "../Box";
import styles from "./styles.module.css";

type PageInfoHeaderWrapperProps = {
  children: ReactNode;
  align?: BoxProps["align"];
  className?: string;
  shouldStackOnMobile?: boolean;
};

const PageInfoHeaderWrapper = ({
  children,
  align = "center",
  className,
  shouldStackOnMobile,
}: PageInfoHeaderWrapperProps) => (
  <Box
    justify="between"
    align={align}
    shrink="0"
    className={cx(styles.header, className, shouldStackOnMobile && styles.mobileStacked)}
  >
    {children}
  </Box>
);

PageInfoHeaderWrapper.displayName = "DS.PageInfoHeaderWrapper";

export default PageInfoHeaderWrapper;
